import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { VorlageAuswaehlenPage } from './vorlage-auswaehlen.page';
import {StoreModule} from '@ngrx/store';
import {reducers} from './vorlage-auswaehlen.reducer';
import {EffectsModule} from '@ngrx/effects';
import {VorlageAuswaehlenPageUiEffects} from './vorlage-auswaehlen.effects.ui';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {IncidentsIncidentVorlagenListeEffects} from '../../../../client-ngrx/incidents';

const routes: Routes = [
  {
    path: '',
    component: VorlageAuswaehlenPage
  }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature('VorlageAuswaehlenPage', reducers),
        EffectsModule.forFeature([
            VorlageAuswaehlenPageUiEffects,
            IncidentsIncidentVorlagenListeEffects
        ]),
        SopiComponentsModule.forRoot(),
        SopiComponentsModule,
    ],
    declarations: [VorlageAuswaehlenPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VorlageAuswaehlenPageModule {
    public static forRoot(): ModuleWithProviders<VorlageAuswaehlenPageModule> {
        return {
            ngModule: VorlageAuswaehlenPageModule,
        };
    }
}
